import React from 'react';
import * as Icons from '@ant-design/icons';
import { I18n } from '@aws-amplify/core';
import { Col, Row } from 'antd';

import { useKimLhc } from '@/context/KimLhc';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useDownloadKimLhcPDF } from '@/hooks/useDownloadKimLhcPDF';
import { useConsolidateKimLhcReport } from '@/hooks/useConsolidateKimLhcReport';
import { SendReportButton } from '@/components/ui/Buttons/SendReportButton';

import * as S from './styles';

interface DownloadPDFProps {
	consolidated: boolean;
	isSandbox: boolean;
	handleOpenSendReportModal: () => void;
}

export function DownloadPDF({
	consolidated,
	isSandbox,
	handleOpenSendReportModal
}: Readonly<DownloadPDFProps>): JSX.Element {
	const { report_id } = useKimLhc();
	const { company, organization } = useApplicationContext();
	const { mutateAsync: downloadPDF, isLoading: downloadingPDF } = useDownloadKimLhcPDF();
	const { mutateAsync: consolidate, isLoading: consolidating } = useConsolidateKimLhcReport();

	const basePayload = {
		id: report_id as string,
		company_id: company?.id as string,
		organization_id: organization?.id as string,
		locale: window.navigator.language
	};

	const isDisablledButtons = downloadingPDF || consolidating;
	

	function handleDownloadPDF(): void {
		if (!basePayload.id || !basePayload.company_id || !basePayload.organization_id) {
			return;
		}

		downloadPDF(basePayload);
	}

	function handleConsolidate(): void {
		if (!basePayload.id || !basePayload.company_id || !basePayload.organization_id) {
			return;
		}

		consolidate({ ...basePayload, consolidated: !consolidated });
	}

	return (
		<Row justify="space-between" style={{ marginTop: '1rem' }}>
			<Col>{isSandbox && <SendReportButton onClick={handleOpenSendReportModal} />}</Col>
			<Col>
				<Row justify="end" gutter={[16, 16]}>
					<Col>
						<S.PdfButton
							loading={downloadingPDF}
							disabled={isDisablledButtons}
							onClick={handleDownloadPDF}
							icon={<Icons.DownloadOutlined />}
						>
							{I18n.get('Download PDF')}
						</S.PdfButton>
					</Col>
					<Col>
						{!consolidated ? (
							<S.ConsolidateButton
								loading={consolidating}
								disabled={isDisablledButtons}
								onClick={handleConsolidate}
								icon={<Icons.LockOutlined />}
							>
								{I18n.get('Consolidate analysis')}
							</S.ConsolidateButton>
						) : (
							<S.DeconsolidateButton
								loading={consolidating}
								disabled={isDisablledButtons}
								onClick={handleConsolidate}
								icon={<Icons.UnlockOutlined />}
							>
								{I18n.get('Deconsolidate')}
							</S.DeconsolidateButton>
						)}
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
